import _get from "lodash/get";
import {
  checkIsAgent,
  checkIsYp,
  getUserAttribute,
  UserAttributes,
} from "shared-auth";
import { ICommonTranslation } from "models/translation";
import defaultsWithFallback from "helpers/defaultsWithFallback";
import { ListItemTranslator } from "helpers/translationHelpers";
import { fallbackTranslation } from "services/api/fallbackData";
import { ISelfTapeRequestNotificationTableTexts } from "./SelfTapeRequestNotificationTable";
import { DEFAULT_CLIENT_AGENCY_ID } from "config/common";

export const readUnreadButtonOptionsKeys = {
  markAsRead: "markAsRead",
  markAsUnread: "markAsUnread",
};

export function prepareTableTexts(
  commonTranslation: ICommonTranslation
): ISelfTapeRequestNotificationTableTexts {
  const grid = defaultsWithFallback(
    commonTranslation?.grid,
    fallbackTranslation.common.grid
  );
  const buttonOptionsTranslator = new ListItemTranslator(
    commonTranslation?.grid?.readUnreadButtonOptions,
    fallbackTranslation.common.grid.readUnreadButtonOptions
  );

  return {
    resultStats: grid.resultStats,
    selectAllControlTexts: {
      selectAllAlertsLabel: grid.selectAll,
      markAsReadAlertsLabel: buttonOptionsTranslator.get(
        readUnreadButtonOptionsKeys.markAsRead
      ),
      markAsUnreadAlertsLabel: buttonOptionsTranslator.get(
        readUnreadButtonOptionsKeys.markAsUnread
      ),
    },
  };
}

interface AgencyPermission {
  AllowSelfSuggest: boolean;
}

export function getEmptySelfTapesFeedText() {
  const agencyPermissions = JSON.parse(
    getUserAttribute(UserAttributes.AgencyPermissions) || "[]"
  );
  const isSelfSuggested =
    _get(agencyPermissions, "[0].AgencyId") !== DEFAULT_CLIENT_AGENCY_ID;
  const isAllowSelfSuggest = agencyPermissions.some(
    (agency: AgencyPermission) => agency.AllowSelfSuggest
  );

  if (checkIsYp())
    return {
      i18nKey: "common:selfTapes.request.emptyFeed.yp",
      link: "https://support.spotlight.com/hc/en-us/articles/35256821979917-Young-Performer-Self-Tape-Request-FAQs",
    };

  if (checkIsAgent() || isAllowSelfSuggest || !isSelfSuggested)
    return {
      i18nKey: "common:selfTapes.request.emptyFeed.agentAndSelfRep",
      link: "https://support.spotlight.com/hc/en-us/articles/35257035694733-Performer-Support-Self-Tape-Request-FAQs-for-Self-Represented-Performers",
    };

  return {
    i18nKey: "common:selfTapes.request.emptyFeed.client",
    link: "https://support.spotlight.com/hc/en-us/articles/35256987011341-Performer-Support-Self-Tape-Request-FAQs-for-Represented-Performers",
  };
}
